import React from 'react';
import classes from "./CountData.module.scss";

const CountData = (props) => {
    // let isNull = props.data && (props.data.length < 1) ? 'Load...' : props.data && props.data[0].id === null ? '0' : props.data.length;
    return (
        <div className={classes.CountData_container}>
            <span>
                {/*{props.data !== undefined ? props.data.length : 0}*/}
                {/*{isNull}*/}
                {props.data && (props.data.length < 1) ? 'Load...' : props.data && props.data[0].id === null ? '0' : props.data.length}
            </span>&nbsp;&nbsp;<span className={"jbfs-title-case"}>{props.label}</span>
        </div>
    );
}

export default CountData;